import {
  useSelector,
  type TypedUseSelectorHook,
} from 'react-redux';
import {
  checkAppVersionSlice,
  type CheckAppVersionState,
} from './slice';

type RootState = {
  [checkAppVersionSlice.name]: CheckAppVersionState;
};

export const selectOpenOutdatedAppVersionModal = (state: RootState): boolean => (
  state[checkAppVersionSlice.name].openOutdatedAppVersionModal
);

export const useCheckAppVersionSelector: TypedUseSelectorHook<RootState> = useSelector;